import { NgModule } from '@angular/core';
import { CxResizeObserverDirective } from './resize-observer.directive';
import { CxResizeObserverService } from './resize-observer.service';

@NgModule({
  declarations: [CxResizeObserverDirective],
  exports: [CxResizeObserverDirective],
  providers: [CxResizeObserverService],
})
export class CxResizeObserverModule {}
